import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import emailSuccess from '../../../../assets/auth/email_success_v2.webp';
import { DialogContent } from '../../../../components/Dialog/DialogUiRedesign/DialogContent';

import styles from './EmailVerificationSuccessStaticContent.module.scss';

interface Props {
  onClose: () => void;
  closeDelay: number;
}

export function EmailVerificationSuccessStaticContent({ onClose, closeDelay }: Props) {
  const { t } = useTranslation();

  useEffect(() => {
    const timeoutId = window.setTimeout(onClose, closeDelay);
    return () => window.clearTimeout(timeoutId);
  }, [onClose, closeDelay]);

  return (
    <DialogContent className={styles.container}>
      <div className={styles.box}>
        <span className={styles.title} data-testid="signup-success-message">
          {t('dialogs.successLowerCase')}
        </span>
        <span className={styles.text}>{t('auth.emailVerifiedSuccessfully')}</span>
      </div>
      <img alt="" className={styles.image} src={emailSuccess} />
    </DialogContent>
  );
}
